import RealConnectionsGames from './RealConnectionGames';

export default RealConnectionsGames;